<div>

  <!-- BUTTONS -->
  <div class="noPrint" style="margin-left:70%; margin-bottom:2%;">

    <button
      mat-raised-button
      color="primary"
      (click)="exportExcel('Districtwise_Statement')">
      Export
    </button>

    <button
      mat-raised-button
      color="primary"
      printTitle="Districtwise Statement"
      printSectionId="print-section"
      ngxPrint>
      Print
    </button>

    <button
      mat-raised-button
      color="accent"
      (click)="close()">
      Close
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="saveSubscriptionBarcodesDataEntry()">
      Save
    </button>

  </div>

  <!-- PRINT AREA -->
  <div class="container" id="print-section">

    <div style="margin:0 15px;">

      <table style="width:100%; border-collapse:collapse;">

        <thead>

          <tr>
            <th colspan="3"
                style="border:1px solid black;
                       padding:8px;
                       font-weight:600;
                       font-size:15px;
                       text-align:center;">

              <span style="float:left;font-size:13px;">
                &nbsp;
              </span>

              विवेक पुस्तक प्रकाशन -
              पुस्तकाचे नाव - {{ book_name }}

              <span style="float:right;font-size:13px;">
                वितरण दि. - {{ dispatchankDate }}
              </span>

            </th>
          </tr>

          <tr>

            <th style="border:1px solid black;padding:6px;text-align:center;">
              जिल्हा
            </th>

            <th style="border:1px solid black;padding:6px;text-align:center;">
              वर्गणीदार संख्या
            </th>

            <th style="border:1px solid black;padding:6px;text-align:center;">
              प्रति संख्या
            </th>

          </tr>

        </thead>

        <tbody>

          <tr *ngIf="isLoading">
            <td colspan="3"
                style="border:1px solid black;padding:20px;text-align:center;">
              Loading...
            </td>
          </tr>

          <ng-container *ngIf="!isLoading">

            <tr *ngFor="let item of filtereddistrictwisesubcout">

              <td style="border:1px solid black;padding:6px;">
                {{ item.district }}
              </td>

              <td style="border:1px solid black;padding:6px;text-align:center;">
                {{ item.total_booksellers }}
              </td>

              <td style="border:1px solid black;padding:6px;text-align:center;">
                {{ item.total_book_copies }}
              </td>

            </tr>

            <tr *ngIf="filtereddistrictwisesubcout.length==0">
              <td colspan="3"
                  style="border:1px solid black;padding:20px;text-align:center;">
                No Data Available
              </td>
            </tr>

            <tr *ngIf="filtereddistrictwisesubcout.length>0" style="font-weight:bold;">

              <td style="border:1px solid black;padding:6px;">
                एकूण
              </td>

              <td style="border:1px solid black;padding:6px;text-align:center;">
                {{ total_sub_count }}
              </td>

              <td style="border:1px solid black;padding:6px;text-align:center;">
                {{ totalparcel }}
              </td>

            </tr>

          </ng-container>

        </tbody>

      </table>

    </div>

  </div>

</div>